import { CardTypeConfig } from '../../interfaces/card-type-config';

export const BANCONTACT_CARD_TYPE_NAME = 'bancontact';

export const BANCONTACT_CARD_TYPE_CONFIG: CardTypeConfig = {
    niceType: 'Bancontact',
    type: BANCONTACT_CARD_TYPE_NAME,
    patterns: [
        45444100,
        45444200,
        45798300,
        479658,
        48107907,
        487104,
        487109,
        49183300,
        49340000,
        49409900,
        51278800,
        516920,
        518272,
        520394,
        52147728,
        52147789,
        522122,
        522962,
        5244354,
        5247840,
        52550604,
        525565,
        539442,
        56135900,
        56135902,
        56136100,
        56140700,
        606005,
        6703
    ],
    gaps: [4, 8, 12],
    lengths: [12, 13, 14, 15, 16, 17, 18, 19],
    code: {
        name: 'CVV',
        size: 0
    }
};
